<template>
	<div class="ReInputRailway  w-100" v-if="region">
    <!-- {{getRegion}} -->
        <!-- 
		<div  v-for="(obj, obj_index) in value" :key="obj_index">
			<div class="row cc-item align-items-center px-3" >
            -->
				<el-select :disabled="!region"
						class="select-primary  w-100 mr-2"
						placeholder="Название станции"
						filterable
						clearable
                        allow-create
						v-model="bufferValue"
				>
					<el-option
						v-for="(sel_opt, sel_index) in masRailway"
						class="select-primary"
						:value="sel_opt.id"
						:label="sel_opt.name"
						:key="sel_index"
					>
					</el-option>
				</el-select>
        <!--
			</div>
		</div>
		
        -->
		
	</div>
</template>

<script>
	import {Select, Option} from 'element-ui';
	export default {
		name: 'ReInputRailway',
		components: {
			[Option.name]: Option,
			[Select.name]: Select,
		},
		props: {
			value: {
				type: String,
				default: '',
		    },
            externalParamsValue:{
                type: Object,
                default(){ return {}; },
            },
			// placeholder: [String, Object],
			required:{
				type: Boolean,
				default: false
			},
			errorLabel: String,
			label: String,			
			region:{
				type: String,
				default: '78',
			},
		},
		data () {
			return {
				ver: 1,
				masRailway: [],				
				isShown: true,
                select_region:'',
                load_region:'',
				bufferValue:'',
			}
		},
		watch: {
			'select_region'(val){
				this.getRailway();

			},
            externalParamsValue:{
                handler(value){
                    // console.log(value);
                    this.extractRegionCode();
                },
                deep: true,
            },
			value(val){
				this.bufferValue = this.$GVO.unlinkObject(val);
			},
			bufferValue(val){
				this.bufferValue = val;
				this.$emit("input", this.bufferValue);
			},
		},
		computed: {
			getRegion(){
                return this.extractRegionCode();
            }
		},
		methods: {
			getRailway(){
                if(this.select_region && this.select_region!=this.load_region){
                    this.load_region = region;
                    // console.log('load railway',this.getRegion, this.select_region, this.externalParamsValue);
                    let region = this.select_region;
                    let filter = {'list':true,'region':this.select_region};
                    this.$GVO.ApiCall('cat_railway.GET',{flt:{...filter}})
                    .then((objApi) => {
                        if(objApi.success === true){
                            if(objApi.data.length > 0){
                                this.masRailway = objApi.data;
                            }
                        }
                    }).catch(errorObjApi => console.error(errorObjApi));
                }else{
                    this.masRailway = [];
                }
			},

			getError(fieldName) {
				return this.errors.first(fieldName);
			},	
            extractRegionCode(){
                // console.log('extract', this.externalParamsValue);
                if(this.externalParamsValue && this.externalParamsValue.MapAddress){
                    try{
                        this.select_region = this.externalParamsValue.MapAddress.address.regioncode
                    }catch(e){
                        // console.log('extract_error', e)
                        this.select_region = this.region;
                    }
                }else{
                    this.select_region = this.region;
                }
                return this.select_region;
            }
		},			
		mounted() {
            this.extractRegionCode();
			this.getRailway();
			this.bufferValue = this.value;
		},
		created(){
			
		}
	}
</script>
<style scoped>
	.ReInputRailway .fieldset{
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.ReInputRailway .fieldset > *{
		width: 100%; 
		margin-bottom: 0px;
	}
	.ReInputRailway .fieldset:not(.no-select) > div:nth-child(1){width: 250px;}
	.ReInputRailway .btnGroup{
		display: flex;
		align-items: center;
	}
	.cc-item{
		margin-bottom: 7px;
	}
	.ReInputRailway >>> .el-input__inner {font-size: 0.75rem;}
	.ReInputRailway >>> .fieldset > div:nth-child(2) .form-control {height: 38px;}

	.clientExists > *{display: block;}
	.clientExists {display: flex; flex-wrap: wrap;}

	/*Этот код вынесен в src/assets/sass/dashboard/custom/_global.scss т.к. там работает, а тут нет - хз почему*/
	
	/* .ReInputRailway >>> .fieldset > div:nth-child(2) .form-control{border-radius: 0.25rem;} */
	.ReInputRailway >>> .fieldset:not(.no-select) > div:nth-child(1) input{
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
	}
	.ReInputRailway >>> .fieldset > div:nth-child(2) input{
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
		border-top-right-radius: 0.25rem;
		border-bottom-right-radius: 0.25rem;
	}
	.ReInputRailway >>> .btnGroup .btn.dropdown-toggle[data-toggle="dropdown"]{margin-bottom: 0px !important;}
	
</style>
